export const KIND_LABELS: Record<string, string> = {
  payroll_estimate: 'Payroll estimate',
  one_time_expense: 'One-time expense',
  unusual_expense: 'Unusual expense',
  receipt_date_override: 'Receipt date override',
  bills_estimate: 'Bills estimate',
  cash_on_hand: 'Cash on hand',
}

export const GENERIC_KIND_LABELS: Record<string, string> = Object.fromEntries(
  Object.entries(KIND_LABELS).filter(([k]) => k !== 'cash_on_hand'),
)

export function assumptionName(row: {
  kind: string
  reason?: string | null
  label?: string | null
}): string {
  if (row.label) return row.label
  if (row.kind !== 'receipt_date_override' && row.reason) return row.reason
  return KIND_LABELS[row.kind] || row.kind
}

export function scopeLabel(projectId: number | null | undefined, projectName?: string | null): string {
  if (projectId == null) return 'Company'
  return projectName || `Project ${projectId}`
}
